export const DEFAULT_PAGE_SIZE = 50;

export const DEFAULT_SCROLL_SIZE = 50;

export const MAX_SCROLL_PAGES = 3;
